import React from 'react'

const Line = () => {
	return <div style={{ height: '1px', width: 'auto', borderBottom: 'solid 1px #c7d4da' }} />
}

export { Line }
